// alphaZ constant calculated from p-value = 0.025 (2-tailed 0.05)
const alphaZ = -1.9599649;
// betaZ constant calculated from type two threshold = 0.2
const betaZ = -0.8416212335729143;

/**
 * Perform a means t-test sample size calculation
 *
 * @note this function assumes the following constants:
 *       - p-value = 0.05
 *       - type two threshold = 0.2
 *
 * @param {number} sampleSize
 * @param {number} baselineRollout
 * @param {number} comparisonRollout
 * @param {float} relchange
 * @param {float} baselineValue
 * @param {float} baselineSTD
 * @param {number} reviewPeriod
 */
function sampleSizeMeans(
  sampleSize,
  baselineRollout,
  comparisonRollout,
  relchange,
  baselineValue,
  baselineSTD,
  reviewPeriod
) {
  const totalRatio = 1.0 / comparisonRollout + 1.0 / baselineRollout;
  const combinedVariance = Math.pow(baselineSTD, 2.0);
  const baselineMean = baselineValue;

  const absDiff = relchange * baselineMean;

  const minSampleFloat =
    (combinedVariance * totalRatio * Math.pow(alphaZ + betaZ, 2)) /
    Math.pow(absDiff, 2);

  const minSample =
    Math.ceil(comparisonRollout * minSampleFloat) +
    Math.ceil(baselineRollout * minSampleFloat);

  function ensureNormality() {
    if (
      Math.ceil(comparisonRollout * minSampleFloat) >= 355 &&
      Math.ceil(baselineRollout * minSampleFloat) >= 355
    ) {
      return (
        Math.ceil(comparisonRollout * minSampleFloat) +
        Math.ceil(baselineRollout * minSampleFloat)
      );
    } else {
      if (comparisonRollout >= baselineRollout) {
        return (
          Math.ceil(
            (comparisonRollout / baselineRollout) *
              Math.max(Math.ceil(baselineRollout * minSampleFloat), 355)
          ) + Math.max(Math.ceil(baselineRollout * minSampleFloat), 355)
        );
      } else {
        return (
          Math.max(Math.ceil(comparisonRollout * minSampleFloat), 355) +
          Math.ceil(
            (baselineRollout / comparisonRollout) *
              Math.max(Math.ceil(comparisonRollout * minSampleFloat), 355)
          )
        );
      }
    }
  }

  const minSample_total = ensureNormality();
  const minDays = Math.ceil(
    reviewPeriod * Math.ceil(minSample_total / (sampleSize * reviewPeriod))
  );

  return [minSample_total, minSample, minDays];
}

export default sampleSizeMeans;
